import PageTitle from '../../components/page-title';
import siteConfig from '../../config/site';

function ComplaintsPolicy() {
  return (
    <div className="h-auto p-4 pb-32 space-y-6 max-w-4xl mx-auto">
      <PageTitle title="Complaints Policy & Procedure" subtitle={siteConfig.name} />
      
      <div className="complaints-policy-content space-y-8">
        <p className="text-base leading-relaxed">
          At {siteConfig.name}, we value the feedback and concerns of our customers, partners,
          and employees. We are committed to addressing complaints effectively and efficiently, ensuring a
          high level of service and satisfaction. This policy outlines the procedure for lodging and handling
          complaints within our company, compliant with UK regulations.
        </p>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">Scope</h2>
          <p className="text-base leading-relaxed">
            This policy applies to all stakeholders, including customers, employees, and partners, who wish to
            lodge a formal complaint against our operations, services, or staff conduct within the United Kingdom.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">Objectives</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Provide a clear and accessible process for submitting complaints.</li>
            <li>Ensure complaints are handled impartially, promptly, and confidentially.</li>
            <li>Use complaint feedback to improve service quality and operational procedures.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">Complaint Submission</h2>
          <p className="text-base leading-relaxed">
            Complaints can be submitted through the following channels:
          </p>
          <ul className="list-disc list-inside space-y-3 ml-4">
            <li>
              <strong>Email:</strong> Send a detailed description of your complaint to{' '}
              <a 
                href={siteConfig.emailLink} 
                className="text-blue-600 hover:text-blue-800 underline"
              >
                {siteConfig.email}
              </a>
            </li>
            <li>
              <strong>Post:</strong> Address your complaint letter to: Complaints Department, {siteConfig.name},{' '}
              {siteConfig.address.full}.
            </li>
          </ul>
          
          <p className="text-base leading-relaxed mt-4">
            When submitting a complaint, please include:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Your full name and contact information.</li>
            <li>A detailed description of the issue, including any relevant dates, times, and individuals involved.</li>
            <li>Any supporting documentation, such as photographs or correspondence.</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">Complaint Handling Procedure</h2>
          <ol className="list-decimal list-inside space-y-4 ml-4">
            <li>
              <strong>Acknowledgement:</strong> We will acknowledge receipt of your complaint within 3 business days.
            </li>
            <li>
              <strong>Investigation:</strong> A dedicated complaints officer will investigate the matter, which may involve
              reviewing documentation and contacting involved parties for further information.
            </li>
            <li>
              <strong>Resolution:</strong> We aim to resolve all complaints within 15 business days. If further information or
              time is required, we will notify you and keep you updated on the progress.
            </li>
            <li>
              <strong>Response:</strong> Upon concluding the investigation, we will provide a written response detailing the
              outcome and any remedial actions taken.
            </li>
          </ol>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">Escalation</h2>
          <p className="text-base leading-relaxed">
            If you are not satisfied with the resolution, you may escalate the complaint to a senior manager by
            contacting{' '}
            <a 
              href={siteConfig.emailLink} 
              className="text-blue-600 hover:text-blue-800 underline"
            >
              {siteConfig.email}
            </a>
            . The escalated complaint will be reviewed, and a final decision will be communicated within 10 business days.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">Confidentiality</h2>
          <p className="text-base leading-relaxed">
            All information related to the complaint will be handled with strict confidentiality and will only be
            shared with necessary parties to resolve the issue.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-800">Monitoring and Review</h2>
          <p className="text-base leading-relaxed">
            {siteConfig.name} will regularly review complaints data to identify trends and areas for
            improvement. Our complaints handling policy and procedures will be reviewed annually to ensure
            compliance and effectiveness.
          </p>
        </section>

        <section className="space-y-4 mt-8">
          <p className="text-base leading-relaxed italic">
            Thank you for helping us improve our services.
          </p>
          
          <div className="bg-gray-50 p-6 rounded-lg mt-6">
            <p className="text-base leading-relaxed">
              <strong className="text-lg">{siteConfig.director}</strong><br />
              <span className="text-gray-600">Director</span><br />
              <span className="text-gray-500 text-sm">21/01/2025</span>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default ComplaintsPolicy;

